// @flow
import * as React from 'react'
import styles from './styles.module.scss'
import cn from 'classnames'

import withTheme from 'hoc/withTheme'
import themes from './themes/__supportedThemes.js'

import EventLogo from './EventLogo'

function MainLogo (props) {
    return (
        <div className={cn(styles.container, props.className)} style={props.style}>
            <EventLogo
                primaryColor={props.theme.primaryColor}
                secondaryColor={props.theme.secondaryColor}
                ternaryColor={props.theme.ternaryColor}
                className={cn(styles.logo, props.logoClassName || '')}
            />
        </div>
    )
}

export default withTheme(themes)(MainLogo)
